
import { Vue, Component } from 'vue-property-decorator'
import DemoConfig from '@/types/demoConfig'
import DemoConfigShowDetailsCard from '@/views/demoConfig/cards/DemoConfigShowDetailsCard.vue'
import DemoConfigShowConfigurationCard from '@/views/demoConfig/cards/DemoConfigShowConfigurationCard.vue'
import ls from '@/ls'

@Component({
  components: { DemoConfigShowConfigurationCard, DemoConfigShowDetailsCard }
})

export default class DemoConfigShow extends Vue {
  settings = {
    routeNames: { list: 'demoConfigs', show: 'demoConfigShow', edit: 'demoConfigEdit' },
    routeParamKey: 'demoConfigId',
    functionNames: { setCurrent: 'setCurrentDemoConfig', clearCurrent: 'clearCurrentDemoConfig', save: 'saveDemoConfig' },
    getterNames: { current: 'currentDemoConfig', loading: 'loadingDemoConfig' }
  }

  currentTab:string = ls.get('demoConfigEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('customerEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : DemoConfig {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }
}
